import { render } from "./SmallProductOverview.vue?vue&type=template&id=3313f86b&scoped=true&ts=true"
import script from "./SmallProductOverview.vue?vue&type=script&lang=ts"
export * from "./SmallProductOverview.vue?vue&type=script&lang=ts"

import "./SmallProductOverview.vue?vue&type=style&index=0&id=3313f86b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3313f86b"]])

export default __exports__